export enum OrgType {
    FieldMed = 'FieldMed',
    GraphiumHealth = 'GraphiumHealth',
}
